import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getFocusGroupActivitiesForProject = async (projectId) => {
    const { data } = await vlqrApi.get(`projects/${projectId}/focusGroupActivities`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useFocusGroupActivitiesForProject = (projectId, options = {}) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['focusGroupActivitiesForProject', projectId],
        queryFn: () => getFocusGroupActivitiesForProject(projectId),
        ...options
    });

    return { data, refetch, isLoading, isError };
};

export default useFocusGroupActivitiesForProject;
